/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { BaseClass } from '../class/baseClass';
import { assets } from '../../core/constants/assets.const';
import { sideBar } from '../../core/constants/sideBar.const';
import { SidebarService } from '../../services/sidebar.service';
import { ConfirmDialogService } from '../../services/confirm-dialog.service';
import { AuthService } from '../../services/auth.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { LoginResponse, RolePermission } from '../../models/auth.model';
import { SideBar } from '../../models/sideBar.model';
import { environment } from '../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'top-technology-side-bar',
  standalone: true,
  imports: [
    DrawerModule,
    ButtonModule,
    AvatarModule,
    RouterModule,
    CommonModule,
    TooltipModule,
    TranslateModule
  ],
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent extends BaseClass implements OnInit {
  protected assetsConst = assets;
  protected isCollapsed = signal(false);
  protected menuItems = signal([...sideBar]);
  private sidebarService = inject(SidebarService);
  private confirmationService = inject(ConfirmDialogService);
  private authService = inject(AuthService);
  private dialogRef = inject(DynamicDialogRef);
  private subscriptionSubject: Subscription | undefined;

  constructor() {
    super();
    this.sidebarService.collapsed$
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe({
        next: (collapsed: boolean) => {
          this.isCollapsed.set(collapsed);
        }
      });
    this.authService.profileDetails
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.handleSideBarPermissions(res);
        }
      });
  }

  ngOnInit(): void {
    this.sidebarService.setSidebarState(false);
  }
 private handleSideBarPermissions(res: LoginResponse): void {
  const ADMIN_ROLE = 1; 

  if (!res.role_permission || res.role_permission.length === 0) {
    const updatedMenuItems = this.menuItems().map((item: SideBar) => ({
      ...item,
      isView: true,
      isEdit: true,
      isDelete: true
    }));
    this.menuItems.set(updatedMenuItems);
    return;
  }
  
  if (res.role === ADMIN_ROLE) {
    const updatedMenuItems = this.menuItems().map((item: SideBar) => ({
      ...item,
      isView: true,
      isAdd: true,
      isDelete: true
    }));
    this.menuItems.set(updatedMenuItems);
  } else {
    this.subAdminRoleHandler(res);
  }
}

private subAdminRoleHandler(res: LoginResponse): void {
  if (!res.role_permission || res.role_permission.length === 0) {
    const updatedMenuItems = this.menuItems().map((item: SideBar) => ({
      ...item,
      isView: true,
      isEdit: true,
      isDelete: true
    }));
    this.menuItems.set(updatedMenuItems);
    return;
  }

  const currentMenuItems = this.menuItems();
  
  const filteredMenuItems = currentMenuItems.filter((item: SideBar) => {
    const matchingPermission = res.role_permission?.find((perm: RolePermission) => {
      if (item.sideBarId && perm.module_id) {
        return perm.module_id === item.sideBarId;
      }
      if (item.module && perm.module) {
        return perm.module.toLowerCase() === item.module.toLowerCase();
      }
      return false;
    });

    if (matchingPermission && matchingPermission.can_view) {
      item.isView = matchingPermission.can_view;
      item.isEdit = matchingPermission.can_add_edit;
      item.isDelete = matchingPermission.can_be_delete;
      return true;
    }
    return false;
  });
  this.menuItems.set(filteredMenuItems);
}
  toggleSubmenu(menuItem: any): void {
    menuItem.isOpen = !menuItem.isOpen;
  }

  btn_logOut(): void {
    this.confirmationService
      .showConfirmationDialog(' ', this.translateService.instant('SureLogout'))
      .then(result => {
        if (result) {
          this.authService
            .logout()
            .pipe(takeUntilDestroyed(this.destroyRef$))
            .subscribe(() => {
              this.dialogRef?.close();
              localStorage.removeItem(environment.storageKey);
              this.router.navigate(['/auth/login']);
            });
        }
      });
  }
}
